import styled from 'styled-components';

export const BodyWrapper = styled.div`
  width: 370px;
  max-height: 400px;
  overflow-y: auto;
  overflow-y: auto;
  justify-content: center;
  grid-template-columns: 1fr;
  display: grid;
  grid-gap: 20px;
  padding: 10px 15px;
`;

export const SymbolFontElement = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 15px;
  align-items: center;
  cursor: pointer;
`;

export const Label = styled.div`
  font-family: Lato;
  font-size: 14px;
  line-height: 1;
`;
